import { LoanCustomer, SearchCustomerDto } from '../../types/LoanCustomerSchema'
import { makeCreate } from '../make-api'

const url = '/customers/search'
const loanCustomerApi = {
  findCustomers: makeCreate<SearchCustomerDto, LoanCustomer[]>(url),
}

export default loanCustomerApi
